const creditPackages = [
  {
    name: 'Deneme',
    credits: 5,
    price: 'Ücretsiz',
    desc: 'Yeni kayıt olan spa işletmelerine özel deneme paketi.',
    features: ['5 iletişim talebi hakkı', 'Terapist havuzu erişimi', 'Temel CRM özellikleri'],
    highlight: false,
  },
  {
    name: 'Standart',
    credits: 10,
    price: 'Satın Alınabilir',
    desc: 'Küçük ve orta ölçekli spa işletmeleri için ideal.',
    features: ['10 iletişim talebi hakkı', 'Gelişmiş filtreleme', 'Tam CRM erişimi', 'Şube bazlı yönetim'],
    highlight: true,
  },
  {
    name: 'Pro',
    credits: 25,
    price: 'Satın Alınabilir',
    desc: 'Büyük spa zincirleri ve yüksek hacimli işletmeler için.',
    features: ['25 iletişim talebi hakkı', 'Öncelikli destek', 'Tam CRM + raporlama', 'Çoklu şube yönetimi'],
    highlight: false,
  },
];

export default function CreditModelSection() {
  return (
    <section id="kredi-modeli" className="w-full bg-off-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-soft-gold-100 text-soft-gold-700 text-xs font-semibold rounded-full mb-4">
            Kredi Sistemi
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
            Adil kredi modeli
          </h2>
          <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto mb-6">
            Spa işletmeleri yalnızca gerçek bağlantı oluştuğunda kredi kullanır. Talep gönderirken kredi düşmez, terapist kabul ederse chat açılır ve kredi kullanılır.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {creditPackages.map((pkg) => (
            <div
              key={pkg.name}
              className={`relative rounded-2xl p-5 md:p-6 border transition-all duration-300 ${
                pkg.highlight
                  ? 'bg-deep-navy-500 border-deep-navy-500 text-white shadow-soft-xl scale-[1.02]'
                  : 'bg-white border-gray-100 hover:border-soft-gold-300 hover:shadow-soft'
              }`}
            >
              {pkg.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-soft-gold-500 rounded-full text-xs font-semibold text-white">
                  En Popüler
                </div>
              )}

              <div className="text-center mb-5">
                <h3 className={`text-lg font-bold mb-1 ${pkg.highlight ? 'text-white' : 'text-deep-navy-500'}`}>
                  {pkg.name}
                </h3>
                <div className="flex items-baseline justify-center gap-1 mb-2">
                  <span className={`text-3xl md:text-4xl font-bold ${pkg.highlight ? 'text-soft-gold-400' : 'text-dark-teal-500'}`}>
                    {pkg.credits}
                  </span>
                  <span className={`text-sm ${pkg.highlight ? 'text-gray-300' : 'text-gray-500'}`}>Kredi</span>
                </div>
                <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                  pkg.highlight ? 'bg-white/10 text-gray-200' : 'bg-off-white text-gray-500'
                }`}>
                  {pkg.price}
                </span>
              </div>

              <p className={`text-xs text-center mb-5 ${pkg.highlight ? 'text-gray-300' : 'text-gray-500'}`}>
                {pkg.desc}
              </p>

              <ul className="space-y-2.5 mb-6">
                {pkg.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2">
                    <i className={`ri-check-line text-sm shrink-0 mt-0.5 ${
                      pkg.highlight ? 'text-soft-gold-400' : 'text-dark-teal-500'
                    }`} />
                    <span className={`text-xs leading-relaxed ${pkg.highlight ? 'text-gray-200' : 'text-gray-500'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                className={`w-full py-2.5 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                  pkg.highlight
                    ? 'bg-soft-gold-500 hover:bg-soft-gold-600 text-white'
                    : 'bg-off-white hover:bg-dark-teal-50 text-deep-navy-500 border border-gray-200 hover:border-dark-teal-200'
                }`}
                disabled
              >
                Yakında
              </button>
            </div>
          ))}
        </div>

        <div className="max-w-2xl mx-auto mt-8 text-center">
          <p className="text-xs text-gray-400">
            Gerçek ödeme ve kredi yönetimi backend entegrasyonu sonrası aktif edilecektir.
          </p>
        </div>
      </div>
    </section>
  );
}